/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoOkIcon16Light } from './LogoOkIcon16Light';
import { LogoOkIcon16Regular } from './LogoOkIcon16Regular';
import { LogoOkIcon16Solid } from './LogoOkIcon16Solid';
import { LogoOkIcon20Light } from './LogoOkIcon20Light';
import { LogoOkIcon20Regular } from './LogoOkIcon20Regular';
import { LogoOkIcon20Solid } from './LogoOkIcon20Solid';
import { LogoOkIcon24Regular } from './LogoOkIcon24Regular';
import { LogoOkIcon24Solid } from './LogoOkIcon24Solid';
import { LogoOkIcon32Regular } from './LogoOkIcon32Regular';
import { LogoOkIcon64Regular } from './LogoOkIcon64Regular';
var sizes = {
    16: {
        light: LogoOkIcon16Light,
        regular: LogoOkIcon16Regular,
        solid: LogoOkIcon16Solid,
    },
    20: {
        light: LogoOkIcon20Light,
        regular: LogoOkIcon20Regular,
        solid: LogoOkIcon20Solid,
    },
    24: {
        regular: LogoOkIcon24Regular,
        solid: LogoOkIcon24Solid,
    },
    32: {
        regular: LogoOkIcon32Regular,
    },
    64: {
        regular: LogoOkIcon64Regular,
    },
};
export var LogoOkIcon = forwardRef('LogoOkIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
